import Horn from '@utils/horn';
import * as Ids from '@utils/ids';
import { reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';

import { IgrayNewPageConfig, IgrayNewPageConfigAdvanced } from '../api/define';

/**
 * 判断是否命中灰度策略
 * @param {string} currentUrl 当前url
 * @param {string} proxyPath 需要灰度的老页面路由
 * @param {number} percent 灰度比例1~100；100表示100%
 */
const isGray = (currentUrl: string, proxyPath: string, percent: number) => {
    if (currentUrl === proxyPath) {
        const acctId = Ids.getAcctId();
        let grayNum = parseInt(`${Math.random() * 100}`, 10);
        if (acctId) {
            grayNum = parseInt(acctId.substr(-2), 10);
        }
        if (grayNum < percent) {
            return true;
        }
    }
    return false;
};

/**
 * 万分比灰度判断
 */
const isGrayAdvanced = (currentUrl: string, proxyItem: IgrayNewPageConfigAdvanced): boolean => {
    if (currentUrl === proxyItem.proxyPath) {
        const acctId = Ids.getAcctId();
        let grayNum = parseInt(`${Math.random() * 10000}`, 10);
        if (acctId) {
            grayNum = parseInt(acctId.substr(-4), 10);
        }
        if (grayNum < proxyItem.percent || (proxyItem.openList || []).indexOf(acctId) !== -1) {
            return true;
        }
    }
    return false;
};

/**
 * 根据灰度信息和url，判断是否跳转到新的页面
 * @param {string} url 跳转的url
 */
const getProxyGrayPage = (url: string): string => {
    try {
        const proxyGrayPages = Horn.getConfigByFieldName<IgrayNewPageConfig[]>(
            Horn.CONFIG_FIELD.URL_REPLACE_GRAY_CONFIG,
        );

        let pageUrl = url;

        if (proxyGrayPages !== null) {
            const grayObj = proxyGrayPages.find(
                (proxyItem: IgrayNewPageConfig | IgrayNewPageConfigAdvanced) => {
                    if (proxyItem) {
                        if ('advanced' in proxyItem) {
                            return isGrayAdvanced(url, proxyItem);
                        } else {
                            return isGray(url, proxyItem.proxyPath, proxyItem.percent);
                        }
                    }

                    return false;
                },
            );

            if (grayObj && grayObj.newPath) {
                reportCustomMetrics(CUSTOM_METRICS.URL_REPLACE_HIT.KEY, 1, {
                    [CUSTOM_METRICS.URL_REPLACE_HIT.TAGS.SRC]: url,
                    [CUSTOM_METRICS.URL_REPLACE_HIT.TAGS.DEST]: grayObj.newPath,
                    [CUSTOM_METRICS.URL_REPLACE_HIT.TAGS.CURRENT_HASH]: window.location.hash,
                });
            }

            pageUrl = grayObj && grayObj.newPath ? grayObj.newPath : url;
        }

        return pageUrl;
    } catch (e) {
        return url;
    }
};

export default getProxyGrayPage;
